// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__h0wtV","infected":"Cards_infected__IF7oq","recovered":"Cards_recovered__2zqy3","deaths":"Cards_deaths__195jy"};